import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=37b6a06e&"
import script from "./PolicyPage.vue?vue&type=script&lang=ts&"
export * from "./PolicyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports